export const NETWORK_ERROR = 'Network Error'
